// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"27a7fa96","70":"5d543b21","71":"0f089592","195":"e6e5e6d6","293":"70a30063","349":"22de5990","360":"9d19f889","401":"bf566026","419":"6762d434","606":"e9fb3ea6","621":"18e52f3f","832":"80dac0fe","870":"317e9998"}[chunkId] + ".chunk.js";
};